import { LayerKey } from './LayerKey'

export class OperationLayerSet {
  private readonly set: Set<string>

  constructor(values?: readonly LayerKey[] | null) {
    this.set = new Set()

    if (values) {
      for (const key of values) {
        this.add(key)
      }
    }
  }

  private serializeKey(key: LayerKey): string {
    return key.toString()
  }

  private deserializeKey(serializedKey: string): LayerKey {
    return new LayerKey(serializedKey)
  }

  add(key: LayerKey): this {
    const serializedKey = this.serializeKey(key)
    this.set.add(serializedKey)
    return this
  }

  has(key: LayerKey): boolean {
    const serializedKey = this.serializeKey(key)
    return this.set.has(serializedKey)
  }

  delete(key: LayerKey): boolean {
    const serializedKey = this.serializeKey(key)
    return this.set.delete(serializedKey)
  }

  clear(): void {
    this.set.clear()
  }

  *values(): IterableIterator<LayerKey> {
    for (const serializedKey of this.set.values()) {
      const key = this.deserializeKey(serializedKey)
      if (key) {
        yield key
      }
    }
  }

  keys(): IterableIterator<LayerKey> {
    return this.values()
  }

  *entries(): IterableIterator<[LayerKey, LayerKey]> {
    for (const key of this.values()) {
      yield [key, key]
    }
  }

  get size(): number {
    return this.set.size
  }

  isEmpty(): boolean {
    return this.set.size === 0
  }

  forEach(
    // oxlint-disable-next-line max-params
    callbackfn: (
      value: LayerKey,
      value2: LayerKey,
      set: OperationLayerSet,
    ) => void,
    thisArg?: unknown,
  ): void {
    for (const key of this.values()) {
      callbackfn.call(thisArg, key, key, this)
    }
  }
}
